import {DatePipe, NgClass}                  from '@angular/common';
import {booleanAttribute, Component, input} from '@angular/core';
import {TableRowBase}                       from '../table-row-base';
import {TableRow}                           from '../table-wrapper/table-wrapper.component';

@Component({
			   selector   : 'app-table-row-base',
			   imports    : [
				   DatePipe,
				   NgClass
			   ],
			   templateUrl: './table-row-base.component.html',
			   styleUrl   : './table-row-base.component.css'
		   })
export class TableRowBaseComponent extends TableRowBase<TableRow> {
	showDate = input(false, {transform: booleanAttribute});
	row = input.required<TableRow>();
	hideIcon = input(booleanAttribute(false), {transform: booleanAttribute});
	detailed = input(false, {transform: booleanAttribute});
}
